//import Vue from 'vue'
import includes from 'lodash/includes';
//import throttle from 'lodash/throttle';
import { EventBus } from '../../mixins/event';
import otMixins from '../../mixins/ot-mixins';

const injectedUrls = [];

export function injectScript(binding) {
  const tag = document.createElement('script');
  const head = document.getElementsByTagName('head')[0];

  tag.src = binding.url;
  tag.async = true;

  if (binding.attributes) {
    Object.keys(binding.attributes).forEach((key) => {
      tag.setAttribute(key, binding.attributes[key]);
    });
  }

  head.appendChild(tag);

  tag.onload = () => scriptLoadedEvent(binding.name, binding.url);
}

export function checkVisible(element, threshold, mode) {
  const _threshold = threshold || 0;
  const _mode = mode || 'visible';

  const rect = element.getBoundingClientRect();
  const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  const above = rect.bottom - _threshold < 0;
  const below = rect.top - viewHeight + _threshold >= 0;

  return mode === 'above' ? above : _mode === 'below' ? below : !above && !below;
}

export function scriptLoadedEvent(name, url) {
  window.eventBus.$emit('script.loaded', {
    name,
    url,
  });
}

export function handleIntersection(entries, observer, bind) {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) return;
    // If the element is in the viewport
    if (bind.url && !includes(injectedUrls, bind.url)) {
      injectedUrls.push(bind.url);
      injectScript(bind);
      observer.unobserve(entry.target); // Unobserve the element
    }
  });
}

export const lazyloadScript = {
  bind: (el, binding) => {
    let config = binding.value;
    if (!el || !config) return;

    const options = {
      root: null, // Use the viewport as the root
      rootMargin: config.rootMargin || '0px', // No margin default
      threshold: config.threshold || 0, // Trigger when 0.1% of the element is visible
    };

    // Use an arrow function to send custom parameters to the callback
    const observer = new IntersectionObserver(
      (entries, observer) => handleIntersection(entries, observer, config),
      options,
    );
    if (!config.isConsentEnabled) {
      observer.observe(el);
    } else {
      //Below Code is, For OT Cookie Consent Events
      otMixins.isConsentEnabled = config.isConsentEnabled;
      let stroyStreamEmitter = config.storyStreamEmitter || 'storyStreamEmitter';
      otMixins.otReviewEmitter = stroyStreamEmitter;
      otMixins.mounted();
      EventBus.$on(stroyStreamEmitter, (status) => status && observer.observe(el));
    }

    //Temperorily hide below lines - will remove permanently in future
    // const maybeInjectScript = throttle(() => {
    //   console.log('element visible', checkVisible(el, 25));

    //   if (checkVisible(el, 25)) {
    //     if (binding.value && binding.value.url && !includes(injectedUrls, binding.value.url)) {
    //       injectedUrls.push(binding.value.url)
    //       injectScript(binding.value)
    //     }
    //     window.removeEventListener('scroll', maybeInjectScript)
    //   }
    // }, 500)

    // window.addEventListener('scroll', maybeInjectScript)

    // call immediately to check if currently in viewport
    //Vue.nextTick(maybeInjectScript)
  },
};
